import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  customerListParams,
  customerListQueryOptions,
  customerListSearchSchema,
  CustomersPage,
} from '@/features/customers';

export const Route = createFileRoute('/_authed/_active/s/$storeId/customers/')({
  staticData: { tours: ['customers.list'] },
  validateSearch: customerListSearchSchema,
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'customers.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...customerListQueryOptions(params.storeId, customerListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // A filter, sort or page change on the list itself must not wait for the fetch: the URL
    // would lag behind, and a second click in the picker would build on the stale filters.
    if (cause !== 'stay') await prefetch;
  },
  component: CustomersPage,
});
